import { Helmet } from "react-helmet";
import { useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { Heading, Input, Button } from "../../components";
import Navbar from "components/Navbar";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

export default function ResetPassword() {
  const {token} = useParams();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [email, setEmail] = useState('test111111111@columbia.edu')
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${apiUrl}/verify_token/` +  token)
    .then(response => {
      setEmail(response.data.email)
    })
    .catch( error => {
      setError(error.message)
    });
  
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError('Passoword does not match')
    } else {
      try {
        const response = await axios.post(`${apiUrl}/reset_password`,  {token, password})
        if (response.data.message) {
          navigate('/home')
        }
      } catch (err) {
        if (err.response.data.message) {
          setError(err.response.data.message);
        } else if (err.request) {
          setError(err.response.data.message);
        } else {
          setError(err.message);
        }
          
        
      }
    }
  };

  
  
  return (
    <>
      <Helmet>
        <title>Create Your Account - Start Your Journey</title>
        <meta
          name="description"
          content="Join our community by creating an account. Stay informed with newsletters and take the first step towards a personalized experience."
        />
      </Helmet>

      <div className="w-full flex flex-col bg-gray-900_01 gap-[30px]">
        <div className="relative left-0 right-0 top-6 m-auto flex flex-1 flex-col items-center gap-[108px] md:gap-[81px] sm:gap-[54px]">
          <Navbar />
          </div>  

        <div className="relative h-[698px] bg-gray-900_01 flex flex-col">
          <div className="flex flex-col items-center justify-center min-h-screen bg-gray-900_01">
              <div className="w-[420px] h-[374px] p-4 flex flex-col gap-[10px] items-center text-white-a700">
                  <Heading className="h-12">Set your password</Heading>
                  <p className="h-3 text-[16px]">You're signing in as {email}, set your account password</p>
                  <p className="h-4 "/>

                  <form className="flex flex-col gap-3 self-stretch" onSubmit={handleSubmit} >
                    <Input value={password} type="password" onChange={(e)=>setPassword(e.target.value)} required
                      shape="square" name="Password Field" placeholder={`Password`} className="bg-gray-900 text-white_a700" style={{ backgroundColor: "var(--gray_900)", borderColor: "var(--gray_900_02)", color: "var(--white_a700)",margin: '0' }} />
                    <Input value={confirmPassword} type="password" onChange={(e)=>setConfirmPassword(e.target.value)} required
                      shape="square" name="Password Field" placeholder={`Confirm Password`} className="bg-gray-900 text-white_a700" style={{ backgroundColor: "var(--gray_900)", borderColor: "var(--gray_900_02)", color: "var(--white_a700)",margin: '0' }} />

                    {error && <p style={{ color: 'red' }}>{error}</p>}
                    <Button type="submit" shape="square" color="indigo_A700" className="px-[34px] sm:px-5">
                      {"Done"}
                    </Button>
                  </form>
                  
              </div>
              <div className="w-[420px] h-[274px]"></div>    
              
          </div>
        </div>   

      </div>
    </>
  );
}
